const doc = [({"da":({"js":({"admin":({"orders":({"create_shipments_in_workplace_button":({"create_shipments_in_workplace":"Opret forsendelser"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;